import { useContext, useEffect, useReducer, useRef, useState } from "react";
import Layout from "../layouts/Layout";
import "./DevicesPage.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import DevicesList from "../components/DevicesList";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const DevicesPage = () => {
  const { page, setPage, authUser, handleAddDeviceModal } = useContext(Context);

  useEffect(() => {
    setPage({
      name: "دستگاه ها",
      slug: "devices",
    });
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          {/* Layout Demo */}
          <div className="col-12 col-md-10 col-lg-8 w-100 h-100 mx-auto">
            <div
              className="card h-100"
              style={{ backgroundColor: "#fff0", boxShadow: "none" }}
            >
              <div className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2">
                <h5>دستگاه‌ها</h5>
                {authUser.is_admin ? (
                  <button
                    type="button"
                    className="btn btn-icon btn-success-app"
                    onClick={handleAddDeviceModal}
                  >
                    <i className="bx bx-plus"></i>
                  </button>
                ) : null}
              </div>
              <DevicesList />
            </div>
          </div>
          {/*/ Layout Demo */}
        </div>
    </HelmetProvider>
  );
};

export default DevicesPage;
